import { getApi } from './index';
import { now, toSeconds } from '../lib/dateTime';
import { getDeviceAndUserStore } from '../storage/stores';
import { captureException } from '../helper/sentry';
import {
  ActiveSafeNetwork,
  getOrganisationName,
} from '../types/store/safeNetworks';

export const reportSafeNetworkEvent = async (
  event: keyof typeof safeNetworkEventCodes,
  safeNetwork: ActiveSafeNetwork
) => {
  const { device: deviceUid, user: userUid } =
    getDeviceAndUserStore().get() || {};
  if (deviceUid && userUid) {
    const orgName = getOrganisationName(safeNetwork);
    const timestampMs = await now();
    const timestamp = toSeconds(timestampMs);
    const body = {
      safe_network_list: [
        // Only accepts one element per request
        {
          type: safeNetworkEventCodes[event],
          timestamp: timestamp,
          network: {
            url: safeNetwork.url,
            ...(orgName && {
              name: orgName,
            }),
          },
        },
      ],
    };
    try {
      await getApi().safeNetworksEvent.post(body, null, { deviceUid, userUid });
    } catch (error) {
      console.error(error);
      captureException(error as Error);
    }
  } else {
    const error = new Error('Device and User Store not properly initialized');
    console.error(error);
    captureException(error);
  }
};

export const safeNetworkEventCodes = {
  safeNetworkEntering: 701,
  safeNetworkLeaving: 702,
  safeNetworkDisablingProtection: 703,
  safeNetworkEnablingProtection: 704,
} as const;
